import { render, staticRenderFns } from "./WhyMR.vue?vue&type=template&id=f2c486f6&scoped=true&lang=pug"
import script from "./WhyMR.vue?vue&type=script&lang=js"
export * from "./WhyMR.vue?vue&type=script&lang=js"
import style0 from "./WhyMR.vue?vue&type=style&index=0&id=f2c486f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c486f6",
  null
  
)

export default component.exports